export const LABELS_NAVIGATE = {
    mapObject:'Карти',
    voyage:'Рейс',
    reportBuilder:'конструктор',
    journal:'Звіти',
    voyageTable:'Сервіси',
    singleVoyage:'Разовий рейс',
    singleVoyageMenu:'Разовий рейс',
    fuelInfo:'Паливо',
    driversInfo:'Водії',
    accountInfo:'Адмін-панель',
    dashboard:'Робочий стіл',
    help:'Допомога',
    legalNotice:'Документи',
    accountAdmin:'Система',

}